import React from 'react';
import ContentWithNavigationSidebar from '../legacy/layouts/ContentWithNavigationSidebar';
import HOME from '../telekardia/components/MicroFrontEndComponent';
import Admin from '../telekardia/components/MicroFrontEndComponent_Admin';
import ROUTE_PATHS from './routePaths';

const Routes = [
  {
    exact: true,
    authenticatedRoute: true,
    path: ROUTE_PATHS.TELEKARDIA_DASHBOARD,
    component: p => (
      <ContentWithNavigationSidebar>
        <HOME />
      </ContentWithNavigationSidebar>
    ),
  },
  {
    exact: true,
    authenticatedRoute: true,
    path: ROUTE_PATHS.TELEKARDIA_APPOINTMENTS,
    component: p => (
      <ContentWithNavigationSidebar>
        <HOME />
      </ContentWithNavigationSidebar>
    ),
  },
  {
    exact: true,
    authenticatedRoute: true,
    path: ROUTE_PATHS.TELEKARDIA_ALL_APPOINTMENT,
    component: p => (
      <ContentWithNavigationSidebar>
        <HOME />
      </ContentWithNavigationSidebar>
    ),
  },
  {
    exact: true,
    authenticatedRoute: true,
    path: ROUTE_PATHS.TELEKARDIA_ADMIN_DASHBOARD,
    component: p => (
      <ContentWithNavigationSidebar>
        <Admin {...p} />
      </ContentWithNavigationSidebar>
    ),
  },
  {
    exact: true,
    authenticatedRoute: true,
    path: ROUTE_PATHS.TELEKARDIA_ADMIN_FEEDBACKS,
    component: p => (
      <ContentWithNavigationSidebar>
        <Admin {...p} />
      </ContentWithNavigationSidebar>
    ),
  },
  {
    exact: true,
    authenticatedRoute: true,
    path: ROUTE_PATHS.TELEKARDIA_ADMIN_CALENDAR,
    component: p => (
      <ContentWithNavigationSidebar>
        <Admin {...p} />
      </ContentWithNavigationSidebar>
    ),
  },
  {
    exact: true,
    authenticatedRoute: true,
    path: ROUTE_PATHS.TELEKARDIA_ADMIN_CONSULTATIONS,
    component: p => (
      <ContentWithNavigationSidebar>
        <Admin {...p} />
      </ContentWithNavigationSidebar>
    ),
  },
];
export default Routes;



// WEBPACK FOOTER //
// ./src/routes/appointmentRoutes.jsx